
const init = function () {
    this.setTotalValue(-1);
}

const _setTotalValue = function (value) {
    const d = this;

    if (value < 0) {
        d.el.innerHTML = ' ';
        return;
    }
    d.el.innerHTML = Math.round(value) + '%';
};


module.exports = el => {
    const Diagram = {};
    Diagram.el = el;


    Diagram.init = init.bind(Diagram);
    Diagram.setTotalValue = _setTotalValue.bind(Diagram);

    return Diagram;
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/TotalValueDisplay.js